import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BirthDayDismissList } from 'src/app/admin/models/birthdayDismiss.model';
import { BirthDayList } from 'src/app/admin/models/birthdaylistmodel';
import { BirthdayListService } from 'src/app/admin/services/birthday-list.service';

@Component({
  selector: 'app-dismiss-birthday-modal',
  templateUrl: './dismiss-birthday-modal.component.html',
  styleUrls: ['./dismiss-birthday-modal.component.scss'],
})
export class DismissBirthdayModalComponent implements OnInit {
@Input() birthdayListList!: BirthDayList
dismissEditList:BirthDayDismissList
currentPage: number = 1;
  itemsPerPage: number = 10
  cityQuery: string = ''
  roomNameQuery: string = '';
  birthdayZoneNameQuery: string = '';
  VisitorNameQuery: string = '';  
  CallDateFromQuery: string = '';
  CallDateToQuery: string = '';
  AppointmentDateFromQuery: string = '';
  AppointmentDateToQuery: string = '';  
  PricePerChildrenFromQuery:string=''
  PricePerChildrenToQuery: string=''
  PlannedChildNumberFromQuery: string = '';
  PlannedChildNumberToQuery: string = '';
  PresentChildNumberQuery: string = '';
  PresentChildNumberFromQuery: string = '';
  PresentChildNumberToQuery: string = '';
  TotalPricePaidQuery: string = '';
  TotalPricePaidFromQuery: string = '';
  TotalPricePaidToQuery: string = '';
  StatusCallQuery: string = '';
  NumberOfBirthdayFromQuery:string=''
  NumberOfBirthdayToQuery: string=''
  AdvancePaymentWillQuery:string=''
   AdvancePricePaidFromQuery:string=''
  AdvancePricePaidToQuery:string=''


  constructor(private modalController: ModalController,private birthdayListService: BirthdayListService) { }

  ngOnInit() {}

getLocalTimeFromServer(utcString: string): string {
  
 if (!utcString) return '';
  const date = new Date(utcString + 'Z');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
}
editDismissBirthdayList() {
   this.StatusCallQuery = '0'
  console.log('eDIT BIRTHDAY LIST ', this.birthdayListList)
    console.log(' birthdayListList.BirthDayStart  ', this.birthdayListList.BirthDayStart)
   this.dismissEditList = new BirthDayDismissList;
   
    this.dismissEditList.id=this.birthdayListList.id
    this.dismissEditList.SavedTimeSlotId=null
    this.dismissEditList.SaveTimeEndSlotId=null
    this.dismissEditList.CallStatus=1

       this.birthdayListService.editBirthdayDissmisList(this.dismissEditList).subscribe(res => {

        this.birthdayListService.getAllBirthday({
          currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
          cityQuery: this.cityQuery,
          roomNameQuery: this.roomNameQuery,
          birthdayZoneNameQuery: this.birthdayZoneNameQuery,
          VisitorNameQuery: this.VisitorNameQuery,        
          CallDateFromQuery: this.CallDateFromQuery,
          CallDateToQuery: this.CallDateToQuery,
          AppointmentDateFromQuery: this.AppointmentDateFromQuery,
          AppointmentDateToQuery: this.AppointmentDateToQuery,
           PricePerChildrenFromQuery:this. PricePerChildrenFromQuery,   
           PricePerChildrenToQuery: this.PricePerChildrenToQuery,    
          PlannedChildNumberFromQuery: this.PlannedChildNumberFromQuery,
          PlannedChildNumberToQuery: this.PlannedChildNumberToQuery,

          PresentChildNumberFromQuery: this.PresentChildNumberFromQuery,
          PresentChildNumberToQuery: this.PresentChildNumberToQuery,
          TotalPricePaidFromQuery: this.TotalPricePaidFromQuery,
          TotalPricePaidToQuery: this.TotalPricePaidToQuery,
          StatusCallQuery: this.StatusCallQuery,
          NumberOfBirthdayFromQuery:this.NumberOfBirthdayFromQuery,
          NumberOfBirthdayToQuery: this.NumberOfBirthdayToQuery,
          AdvancePaymentWillQuery:this.AdvancePaymentWillQuery,
          AdvancePricePaidFromQuery:this.AdvancePricePaidFromQuery,
          AdvancePricePaidToQuery:this.AdvancePricePaidToQuery
        })

       this.dismissModal();

      }, (err) => {
        JSON.stringify(err.error.title);
      });  
  }
dismissModal() {
    this.modalController.dismiss();
  }


  }